<div style="padding: 1em;">
  Double-click a row to view entity record history.
  <lib-new-table-editor #mainLogs
  modelName="11th OVC Application Log"
  (messageEmitter)="sbCmpMsgSvc.handleStarbaseComponentMsg($event)"
  [userViewOptions]="logUserViewOpts"
  [usePagination]="true"
  [loadAllClientside]="false"
  [dataFilterParams]="logFilterParams"
  (dblClickEmitter)="sbCmpMsgSvc.recordHistoryEmitter.emit($event['entityGuid'])"
  [tableEditable]="false"
  [dataSvc]="logDataSvc"
  [rppChoices]="[25, 50, 100]"
  [tableHeight]="'75vh'"
  [columns]="LogCols">
    <h4 style="text-align: left;">
      Research Arsenal Application Logs <br>
      <div class="row" style="padding-left: 15px;">
        <app-log-search #logSearch  (searchOutput)="searchTyping($event)" (errorOutput)="handleSearchError($event)" (resultsOutput)="quickSearchLogs($event)"></app-log-search><!-- [data]="(logDataSearch$ | async)?.collection" -->
        <ng-container *ngTemplateOutlet="logLevelsDropdown"></ng-container>
      </div>
    </h4>
    <ng-template #rowTemplate let-rowData="rowData" let-columnDefinitions="logCols" let-compactMode="compactMode" let-columnDividers="columnDividers">
      <span style="display: contents;" lib-table-row
      [ngClass]="{'errorRow': rowData.level == 'Error', 'fatalRow': rowData.level == 'Fatal'}"
      [rowData]="rowData"
      [columnDefinitions]="LogCols"
      [showColumnDividers]="columnDividers"
      [allowEdit]="false"
      [compactMode]="compactMode"
      ></span>
    </ng-template>
    <span footerRow class="footerRow">
      <td style="border-top: 1px solid #333;" title="Requires admin">
        <label for="showExceptChk" class="fieldLabel">
          Show exceptions
        </label>
      </td>
      <td>
        <label class="switch">
          <input type="checkbox" id="showExceptChk" (click)="toggleExceptions()" [(ngModel)]="showExceptions"><span class="slider round"></span>
        </label>
      </td>
      <td></td>
    </span>
  </lib-new-table-editor>
</div>

<ng-template #logLevelsDropdown>
  <div class="btn-group dropdown ms-2" style="vertical-align: baseline;" matTooltip="Filter by Log Levels">
    <button type="button" id="llDropdownMenu" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="btn btn-sm btn-outline-secondary dropdown-toggle">
      <span class="badge badge-dark" style="line-height: 1.25em;" *ngIf="currentLogLevelFiltersSet.length">{{ currentLogLevelFiltersSet.length }}</span>
      Log Levels
    </button>
    <div class="dropdown-menu" style="max-height: 200px; overflow: auto;" aria-labelledby="ctDropupMenu">
      <button class="dropdown-item" [ngClass]="{'disabled': !currentLogLevelFiltersSet.length}"
        (click)="clearLogLevelFilters()">
        Clear this filter
      </button>
      <div class="dropdown-divider"></div>
      <a class="dropdown-item" *ngFor="let ll of logLevels" (click)="updateLogLevelFilters(ll)">
        <i class="fal fa-check me-1" *ngIf="currentLogLevelFiltersSet.includes(ll)"></i>
        <span [ngClass]="{'errorRow': ll == 'Error', 'fatalRow': ll == 'Fatal'}">{{ ll }}</span>
      </a>
    </div>
  </div>
</ng-template>